import _str from "shared/util/_str";

export const ERRORS = {
	OAuthError: _str("Your session has expired. Refresh the page to fix this."),
	SocialError: _str("Couldn’t communicate with Instagram. Try again later."),
	DEFAULT: _str("Something went wrong; we couldn’t retrieve their photos."),
};

// if the image wrapper is smaller than this size, bail on the image
export const MIN_SIZE = 250;



// WEBPACK FOOTER //
// ./src/apps/photo_overlay/util/constants.js